import Controller, { inject as controller } from '@ember/controller';

export default class MarketRevenueInsightIssueTableController extends Controller {
  // Parent controller
  @controller('market.revenue-insight') multi;

  get hotelsWithIssues() {
    return this.multi?.hotelsWithIssues;
  }
}
